export default "__VITE_ASSET__M88PE9kC__"